import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layouts/Auth";
import Input from "../components/inputs/Input";
import Notice from "../components/notice/Notice";
import Text from "../components/typography/Text";
import AuthContext from "../contexts/auth";
import Button from "../components/buttons/Button";

export default ({ history, location, match }) => {
  // TODO: REDIRECT USER TO PROFILE PAGE IF ALREADY LOGGED
  const { login } = React.useContext(AuthContext);
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState();
  // get from url if not null
  const urlParams = new URLSearchParams(location.search);
  const redirection = urlParams.get("redirect_url");
  let verify = false;
  let noticeType = "";
  let activationMessage = "";
  const role = urlParams.get("user_role") || "designer";
  const onSignIn = async () => {
    const loginError = await login(username, password);
    if (!loginError) history.push(redirection || "/");
    else setError(loginError);
  };
  if (urlParams.get("user_verify") === "1") {
    verify = true;
    activationMessage = "activation_success_message_" + role;
    noticeType = "success";
  } else if (urlParams.get("user_verify") === "0") {
    verify = true;
    activationMessage = "activation_expired_notice";
    noticeType = "error";
  }
  return (
    <Layout title="Login">
      <div className="pLogin">
        {verify && (
          <Notice type={noticeType} optionName={activationMessage}></Notice>
        )}
        <h3>Log in</h3>
        <Input
          label="E-mail"
          required
          value={username}
          setValue={setUsername}
          onKeyDown={e => (e.keyCode === 13 ? onSignIn() : null)}
        />
        <div className="pLogin_password">
          <Link
            className="pLogin_forgotPassword"
            to="/forgottenpassword"
            tabIndex="-1"
          >
            Forgot Password?
          </Link>
          <Input
            label="Password"
            required
            value={password}
            setValue={setPassword}
            type="password"
            onKeyDown={e => (e.keyCode === 13 ? onSignIn() : null)}
          />
        </div>
        {error && (
          <div
            className="pLogin_error"
            dangerouslySetInnerHTML={{ __html: error.message }}
          ></div>
        )}
        <Button onClick={onSignIn} big full>
          Log in
        </Button>
        <div className="pLogin_signup">
          <Text small>
            Not a member? <Link to="/signup">Sign up</Link> now
          </Text>
        </div>
      </div>
    </Layout>
  );
};
